import React from 'react';
import {CheckBox, Text, Flex, TextColor} from '@priority-software/priority-style-react';
import styles from '../styles/editDropdownItem.module.scss';
import {createDataTestId} from '../../../../../../utils/dataTestId';

type ItemProps = {
    index: number;
    title: string;
    onClick: () => void;
    textColor?: TextColor;
};

export const Item = ({index, title, onClick, textColor = 'primary-700'}: ItemProps) => {
    return (
        <div
            className={styles.item}
            onClick={onClick}
            {...createDataTestId(`list-item-${title}`, false)}
        >
            <Text wrap={false} skin={'paragraph-2'} textColor={textColor}>
                {title}
            </Text>
        </div>
    );
};

type ItemWithCheckboxProps = {
    index: number;
    title: string;
    checked: boolean;
    onClick: (checked: boolean) => void;
};

export const ItemWithCheckbox = ({index, title, checked, onClick}: ItemWithCheckboxProps) => {
    return (
        <div
            className={styles.item}
            onClick={() => onClick(!checked)}
            {...createDataTestId(`checkbox-item-${title}`, false)}
        >
            <Flex justifyContent={'flex-start'}>
                <CheckBox checked={checked} />
                <Text wrap={false} skin={'paragraph-2'}>
                    {title}
                </Text>
            </Flex>
        </div>
    );
};
